import { useRef } from 'react'

// Components
import ReportsDynamicForm from '../ReportsDynamicForm/ReportsDynamicForm'
import AlertDialog from 'components/AlertDialog/AlertDialog'
import { Visibility } from '@mui/icons-material'
import { CustomModal } from 'components/molecules/Modal/Modal'
import { LoadingButton } from '@mui/lab'
import { AttachmentPreview } from '../AttachmentPreview'

// Types
import { ImplantReportSenderModalProps } from '../ImplantReportSender.types'
import { ReportsDynamicFormRef } from '../ReportsDynamicForm/types'

// Logic
import { useImplantReportSenderModalLogic } from './ImplantReportSenderModal.logic'
import { ResponsivePdfPreviewModal } from '../ImplantReportPreviewModal'

export const ImplantReportSenderModal = (
  props: ImplantReportSenderModalProps
) => {
  const {
    attachments,
    fileInputRef,
    reportAlreadySentModal,
    previewModalOpen,
    previewPdfUrl,
    handleAttach,
    handleOnClose,
    handleClosePreview,
    handleRemoveAttachment,
    setReportAlreadySentModal,
    handleAttachementFileChange,
    isLoadingSendAndPreview,
    handleFormSubmit,
    template,
  } = useImplantReportSenderModalLogic(props)

  const { implantReportInputs, inputModalOpen, provider } = props

  const formRef = useRef<ReportsDynamicFormRef>(null)

  return (
    <>
      <CustomModal
        open={inputModalOpen}
        secondaryButtonAction={handleOnClose}
        header={`${implantReportInputs?.['reportType']?.name} Report`}
        isLoadingState={isLoadingSendAndPreview}
        primaryButtonText="Submit"
        handleOnSubmit={() => formRef.current?.submitForm(false)}
        icon={<></>}
      >
        {reportAlreadySentModal && (
          <AlertDialog
            isOpen={reportAlreadySentModal}
            mode="primary"
            title="Report Already Sent"
            description="This report has already been sent to the referring physician. Are you sure you want to send it again?"
            secondaryButtonAction={() => setReportAlreadySentModal(false)}
            primaryButtonAction={() => formRef.current?.submitForm(false)}
            primaryButtonText="Submit"
            isPrimaryLoading={isLoadingSendAndPreview}
            zIndex={1300}
          />
        )}

        {template && (
          <ReportsDynamicForm
            ref={formRef}
            template={template}
            onSubmit={handleFormSubmit}
            provider={provider}
          />
        )}

        {template?.acceptsAttachments && (
          <>
            <AttachmentPreview
              attachments={attachments}
              onRemoveAttachment={handleRemoveAttachment}
              onAttach={handleAttach}
              maxAttachments={4}
            />

            <input
              hidden
              type="file"
              ref={fileInputRef}
              accept=".pdf, image/*"
              onChange={handleAttachementFileChange}
            />
          </>
        )}

        <LoadingButton
          variant="outlined"
          startIcon={<Visibility />}
          onClick={() => formRef.current?.submitForm(true)}
          disabled={isLoadingSendAndPreview}
          sx={{ mr: 2 }}
          fullWidth
          loading={isLoadingSendAndPreview}
        >
          Preview Report
        </LoadingButton>
      </CustomModal>

      {/* Preview Modal */}
      <ResponsivePdfPreviewModal
        open={previewModalOpen}
        onClose={handleClosePreview}
        content={previewPdfUrl}
        reportType={implantReportInputs?.['reportType']?.name ?? ''}
        isLoading={isLoadingSendAndPreview}
      />
    </>
  )
}
